import React, { useState, useEffect } from 'react';
// import headerImg from '../../assets/kvshw.png'
import './header.css';
import { easeIn, motion } from "framer-motion"
import countryRectangle from '../../assets/country_rectangle.png'
import countryElipse from '../../assets/country_elipse.png'
import Finland from '../../assets/Finland.png'
import sriLanka from '../../assets/SriLanka.png'
import Resume from '../../assets/Kavishwa_Wendakoon_CV.pdf'





const Header = () => {
    const [isVisible, setIsVisible] = useState(true);

    const handleDisplay = () => {
        if (window.scrollY > 100) {
            setIsVisible(!isVisible)
        }
    }

    return (
        <>
            <div className='.kvshw__header w-[100vw] h-[100vmin] bg-portfolio bg-cover bg-no-repeat bg-center text-white'>

                <div className='based_design'>
                    <img src={countryRectangle} alt="" srcset="" className='h-[9vmin] absolute top-[50vmin]' />
                    <img src={countryElipse} alt="" srcset="" className='h-[8vmin] absolute top-[50.5vmin] left-[12vmin]' />
                </div>
                <div className='based_in_finland'>
                    <p className='absolute h-[6vmin] text-[1.7vmin] w-[7vmin] text-black top-[52.1vmin] left-[3vmin]'>Based in Finland</p>
                    <motion.img animate={{ rotate: 360 }}
                        transition={{ type: easeIn, from: 0, duration: 10, repeat: Infinity, repeatDelay: 0 }} src={Finland} alt="" srcset="" className='h-[6vmin] absolute top-[51.5vmin] left-[14.5vmin]' />
                </div>

                <div className='from_sri_lanka hidden'>
                    <p className='absolute h-[6vmin] text-[1.7vmin] w-[8vmin] text-black top-[52.1vmin] left-[3vmin]'>From <br></br> Sri Lanka</p>
                    <img src={sriLanka} alt="" srcset="" className='h-[6vmin] absolute top-[51.5vmin] left-[14.5vmin]' />
                </div>
                <div className='text-white font-medium text-[3vmin] absolute  top-[50vmin] right-[20vmin]'>
                    <h2 className=''>Full-Stack Developer</h2>
                    <h2 className=''>UI/UX Designer</h2>

                </div>
                <div className='name_XL absolute bottom-[4vmin] w-[100%]  text-clip overflow-hidden whitespace-nowrap'>
                    <motion.h1 animate={{ x: -5000 }} transition={{ yoyo: 10, repeat: Infinity, duration: 50, ease: "easeIn" }} className='text-[170px] w-[100vw] font-bold text-clip translate-x-[0]'>Kavishwa Wendakoon - Transforming Complex Ideas into Elegant Code</motion.h1>
                    {/* <motion.h1 animate={{ x: -5000 }} transition={{ yoyo: 10, repeat: Infinity, duration: 50, ease: "easeIn" }} className='text-[170px] w-[100vw] font-bold text-clip translate-x-[0]'>Kavishwa Wendakoon - Transforming Complex Ideas into Elegant Code</motion.h1> */}

                </div>
            </div >
        </>
    )
}

export default Header


// bottom-end flex flex-row justify-between w-full absolute bottom-0 h-[25vh] items-end